import myAxios from "@/utils/request";
export default {
  // 专家信息管理
  getExpertList(params) {
    return myAxios.post("/api/specialist/specialistpaging", params);
  },
  batchExpertDelete(params) {
    return myAxios.post("/api/specialist/deletespecialist", params);
  },
  expertSNUp(params) {
    const { id } = params;
    return myAxios.get("/api/specialist/uporder?id=" + id);
  },
  expertSNDown(params) {
    const { id } = params;
    return myAxios.get("/api/specialist/downorder?id=" + id);
  },
  modExpertSN(params) {
    return myAxios.post("/api/specialist/specijumptop", params);
  },
  addExpert(params) {
    return myAxios.post("/api/specialist/specialadd", params);
  },
  modifyExpert(params) {
    return myAxios.post("/api/specialist/specialmodify", params);
  },
  getExpertInfo(params) {
    const { id } = params;
    return myAxios.get("/api/specialist/getinfo?id=" + id);
  },

  // 服务信息管理
  getServiceList(params) {
    return myAxios.post("/api/specialistservice/getservicepaging", params);
  },
  batchServiceDelete(params) {
    return myAxios.post("/api/specialistservice/delspecialistser", params);
  },
  addService(params) {
    return myAxios.post("/api/specialistservice/specialistserviceadd", params);
  },
  modifyService(params) {
    return myAxios.post(
      "/api/specialistservice/modifyspecialistservice",
      params
    );
  },
  getServiceInfo(params) {
    const { id } = params;
    return myAxios.get("/api/specialistservice/spinfo?id=" + id);
  },

  // 服务申请管理
  getServiceApplyList(params) {
    return myAxios.post("/api/specialistapply/getspserviceapppaging", params);
  },
  batchServiceApplyDelete(params) {
    return myAxios.post("/api/specialistapply/delspecialistapply", params);
  }
};
